export const translations = {
  en: {
    greeting: "Hi",
    surveyIntro: "Great job with your training! 😊",
    surveyRequest: "You help us a lot if you take a minute to answer a short survey about the training so far. Thank you in advance!",
    surveyLink: "Imvi's survey",
    importantImprovements: "Significant Improvements 🎉",
    theseAre: "These are:",
    thisIs: "This is:",
    readingSpeedTitle: "Reading Speed",
    trainingTitle: "Training",
    recommendationTitle: "Recommendation",
    congratsMessage: "Congratulations! Well done!",
    trainingProgressMessage: `You have made progress by training. Keep it up!
      It is important to keep training during the upcoming weeks to potentially improve your reading speed and vergence further. Train at least 4 times a week for your results to become permanent and to automatize your improved eye coordination in everyday life.`,
    minTrainingRecommendation: "We recommend you to train 4 times per week for the next 6 weeks.",
    trainingGoodbye: "Good luck with the rest of your training!",
    socialShareRequest: "We would also appreciate if you would tell others you know about Imvi and recommend our training.",
    socialMediaTitle: "Follow and like us on social media:",
    vergenceTitle: "Vergence Test Scores",
    readingSpeedChartTitle: "Reading Speed Scores",
    symptomScoreLabel: "Symptom Score",
    lettersLabel: "Letters",
    wordsLabel: "Words",
    sentencesLabel: "Sentences",
    excellent: "Excellent! 🤗",
    greatJob: "Great job! 👏",
    week: "Week",
  },
  sv: {
      // General
      greeting: "Hej",
      surveyIntro: "Jättebra kämpat med träningen! 😊",
      surveyRequest: "Du hjälper oss mycket om du tar någon minut och svarar på en kort enkät om träningen så här långt. Stort tack på förhand!",
      surveyLink: "Imvi:s enkät",
      loading: "Laddar...",
      copied: "✅ Kopierad",
  
      // Improvements Section
      importantImprovements: "Viktiga förbättringar 🎉",
      theseAre: "Dessa är:",
      thisIs: "Denna är:",
  
      // Charts and Measurements
      vergenceTitle: "Utveckling av samsyn",
      readingSpeedChartTitle: "Utveckling av läshastighet",
      symptomScoreLabel: "Symptompoäng",
      readingSpeedTitle: "Läshastighet",
      lettersLabel: "Bokstäver",
      wordsLabel: "Ord",
      sentencesLabel: "Meningar",
  
      // Training Section
      trainingTitle: "Träning",
      excellent: "Utmärkt! 🤗",
      greatJob: "Toppen! 👏",
      trainingMessage: "Du har gjort framsteg genom att träna. Fortsätt så!",
  
      // Recommendation Section
      recommendationTitle: "Rekommendation",
      congratsMessage: "Grattis! Bra jobbat!",
      trainingProgressMessage: `Du har gjort framsteg genom att träna. Fortsätt så!
        Det är viktigt att fortsätta träna de kommande veckorna för att eventuellt kunna förbättra din läshastighet och samsyn ännu mer. Träna minst 4 gånger i veckan för att dina resultat ska bli bestående och för att din förbättrade ögonkoordination ska bli automatisk i vardagen.`,
      minTrainingRecommendation: "Vi rekommenderar minst 4 träningar per vecka de resterande 6 veckorna, men det gör inget om du tränar mer.",
      trainingGoodbye: "Lycka till med resten av din träning!",
  
      // Social Media Section
      socialShareRequest: "Vi skulle även uppskatta om du vill berätta om Imvi för andra du känner och tipsa om vår träning.",
      socialMediaTitle: "Följ och gilla oss gärna på sociala medier:",
  
      // Test Result Messages
      improvementPrefix: "Förbättring",
      scoreLabel: "Poäng",
      averageLabel: "Genomsnitt",
  
      // Chart Labels
      chartWeek: "Vecka",
      chartScore: "Poäng",
      chartImprovement: "Förbättring",
  
      // Calibration
      calibration: "Kalibrering",
      calibrationMessage: "Din kalibrering visar goda resultat.",
  
      // Error Messages
      noDataAvailable: "Ingen data tillgänglig",
      errorLoading: "Ett fel uppstod vid laddning av data",
  
      // Test Categories
      vergenceFunction: "Vergensfunktion",
      readingAbility: "Läsförmåga",
      eyeCoordination: "Ögonkoordination",
  
      // Progress Messages
      significantProgress: "Du har gjort betydande framsteg",
      moderateProgress: "Du har gjort måttliga framsteg",
      slightProgress: "Du har gjort små framsteg",
  
      // Additional UI Elements
      showMore: "Visa mer",
      showLess: "Visa mindre",
      details: "Detaljer",
      summary: "Sammanfattning",
  
      // Social Media Links Text
      facebookLink: "Besök oss på Facebook",
      instagramLink: "Följ oss på Instagram",
      linkedinLink: "Hitta oss på LinkedIn",
      youtubeLink: "Se våra videos på YouTube",
  
      // Report Sections
      reportIntro: "Träningsrapport",
      reportSummary: "Sammanfattning",
      reportDetails: "Detaljerad analys",
      reportConclusion: "Slutsats",
  
      // Button Labels
      copyReport: "Kopiera rapport",
      downloadReport: "Ladda ner rapport",
      shareReport: "Dela rapport",
  
      // Time Periods
      weekLabel: "Vecka",
      weeksLabel: "veckor",
      monthLabel: "månad",
      monthsLabel: "månader",
  
      // Assessment Labels
      initialAssessment: "Initial bedömning",
      finalAssessment: "Slutbedömning",
      progressAssessment: "Framstegsbedömning",
  
      // Statistical Terms
      average: "Genomsnitt",
      improvement: "Förbättring",
      baseline: "Utgångsvärde",
      currentLevel: "Nuvarande nivå",
  
      // Encouragement Messages
      keepGoing: "Fortsätt det goda arbetet!",
      almostThere: "Du är nästan framme!",
      greatProgress: "Fantastiska framsteg!",
  
      // Footer Messages
      copyright: "© Imvi Labs AB",
      privacyPolicy: "Integritetspolicy",
      termsOfService: "Användarvillkor",
      contact: "Kontakta oss",
  
      // Chart Tooltips
      chartTooltipProgress: "Din framgång över tid",
      chartTooltipComparison: "Jämförelse med baseline",
      chartTooltipAverage: "Genomsnittlig förbättring",
      week: "Vecka",
    }
};